<ng-container [ngSwitch]="['wettarena', 'b500'] | getProductName">
  <div *ngSwitchCase="'wettarena'" class="cashback-wrapper">
    <div class="cashback-info">
      <div style="position: relative" class="cashback-info-item">
        <image-loader-utils customUrl="https://wettarenacdn.s3.eu-central-1.amazonaws.com/cms/cashback/cashback1.png" imageFormat="png"></image-loader-utils>
        <div
          mat-raised-button
          class="forgot-password-submit-button"
          style="position: absolute; bottom: 37px; left: 0; height: 80px; width: 100%; cursor: pointer"
          (click)="joinCashback()"></div>
      </div>
      <div class="cashback-info-item">
        <image-loader-utils customUrl="https://wettarenacdn.s3.eu-central-1.amazonaws.com/cms/cashback/cashback2.png" imageFormat="png"></image-loader-utils>
      </div>
      <div class="cashback-info-item">
        <image-loader-utils customUrl="https://wettarenacdn.s3.eu-central-1.amazonaws.com/cms/cashback/cashback3.png" imageFormat="png"></image-loader-utils>
      </div>
      <div class="cashback-info-item">
        <image-loader-utils customUrl="https://wettarenacdn.s3.eu-central-1.amazonaws.com/cms/cashback/cashback4.png" imageFormat="png"></image-loader-utils>
      </div>
    </div>
    <div class="cashback-info">
      <div>
        <ng-container *ngIf="this._UiHelper.getTheme() === 'dark'">
          <image-loader-utils customUrl="https://wettarenacdn.s3.eu-central-1.amazonaws.com/cms/cashback/cashback5-dark.png" imageFormat="png"></image-loader-utils>
        </ng-container>
        <ng-container *ngIf="this._UiHelper.getTheme() === 'light'">
          <image-loader-utils customUrl="https://wettarenacdn.s3.eu-central-1.amazonaws.com/cms/cashback/cashback5.png" imageFormat="png"></image-loader-utils>
        </ng-container>
      </div>
    </div>
  </div>
  <div *ngSwitchCase="'b500'" class="cashback-wrapper">
    <div class="cashback-info">
      <div style="position: relative" class="cashback-info-item">
        <image-loader-utils customUrl="https://wettarenacdn.s3.eu-central-1.amazonaws.com/cms/cashback/cashback1.png" imageFormat="png"></image-loader-utils>
        <div
          mat-raised-button
          class="forgot-password-submit-button"
          style="position: absolute; bottom: 37px; left: 0; height: 80px; width: 100%; cursor: pointer"
          (click)="joinCashback()"></div>
      </div>
      <div class="cashback-info-item">
        <image-loader-utils customUrl="https://wettarenacdn.s3.eu-central-1.amazonaws.com/cms/cashback/cashback2.png" imageFormat="png"></image-loader-utils>
      </div>
      <div class="cashback-info-item">
        <image-loader-utils customUrl="https://wettarenacdn.s3.eu-central-1.amazonaws.com/cms/cashback/cashback3.png" imageFormat="png"></image-loader-utils>
      </div>
      <div class="cashback-info-item">
        <image-loader-utils customUrl="https://wettarenacdn.s3.eu-central-1.amazonaws.com/cms/cashback/cashback4.png" imageFormat="png"></image-loader-utils>
      </div>
    </div>
    <div class="cashback-info">
      <div>
        <ng-container *ngIf="this._UiHelper.getTheme() === 'dark'">
          <image-loader-utils customUrl="https://wettarenacdn.s3.eu-central-1.amazonaws.com/cms/cashback/cashback5-dark.png" imageFormat="png"></image-loader-utils>
        </ng-container>
        <ng-container *ngIf="this._UiHelper.getTheme() === 'light'">
          <image-loader-utils customUrl="https://wettarenacdn.s3.eu-central-1.amazonaws.com/cms/cashback/cashback5.png" imageFormat="png"></image-loader-utils>
        </ng-container>
      </div>
    </div>
  </div>
  <div *ngSwitchDefault class="cashback-wrapper">
    <div class="cashback-info">
      <div style="position: relative">
        <image-loader-utils customUrl="https://wettarenacdn.s3.eu-central-1.amazonaws.com/cms/cashback/cashback1.png" imageFormat="png"></image-loader-utils>
        <div
          mat-raised-button
          class="forgot-password-submit-button"
          style="position: absolute; bottom: 37px; left: 0; height: 80px; width: 100%; cursor: pointer"
          (click)="joinCashback()"></div>
      </div>
      <div>
        <image-loader-utils customUrl="https://wettarenacdn.s3.eu-central-1.amazonaws.com/cms/cashback/cashback2.png" imageFormat="png"></image-loader-utils>
      </div>
      <div>
        <image-loader-utils customUrl="https://wettarenacdn.s3.eu-central-1.amazonaws.com/cms/cashback/cashback3.png" imageFormat="png"></image-loader-utils>
      </div>
      <div>
        <image-loader-utils customUrl="https://wettarenacdn.s3.eu-central-1.amazonaws.com/cms/cashback/cashback4.png" imageFormat="png"></image-loader-utils>
      </div>
    </div>
    <div class="cashback-info">
      <div>
        <image-loader-utils customUrl="https://wettarenacdn.s3.eu-central-1.amazonaws.com/cms/cashback/cashback5.png" imageFormat="png"></image-loader-utils>
      </div>
    </div>
  </div>
</ng-container>
